export class CaracteristicaModel {
    tipo:string;
    codigo:string;
    descripcion:string;

    constructor(){}
}